import { AsyncAutocomplete } from 'modules/form';
import { gql } from 'modules/GraphQL';
import React from 'react';
import { whatsappMartin } from '../config';
import useUser from 'modules/User/hooks/useUser';

const LIST_OCCUPATIONS = gql`
  query Occupations($page: NonNegativeInt, $limit: NonNegativeInt, $q: String) {
    items: occupations(sort: "name", page: $page, limit: $limit, q: $q) {
      pageInfo {
        count
        page
        limit
      }
      items {
        _id
        name
      }
    }
  }
`;
type Occupation = {
  _id: string;
  name: string;
};

type SelectOccupationProps = Omit<React.ComponentProps<typeof AsyncAutocomplete>, 'labelField' | 'queryFn'>;

const SelectOccupation: React.FC<SelectOccupationProps> = ({ isMulti, onChange, ...props }) => {
  const { user } = useUser();
  return (
    <AsyncAutocomplete
      queryFn={LIST_OCCUPATIONS}
      isMulti={isMulti}
      labelField={(({ name }: any) => name) as any}
      noOptionsMessage={({ inputValue }) =>
        inputValue === '' ? (
          'Tape quelques lettres pour chercher'
        ) : (
          <span className="text-left block">
            Aucune option trouvée pour <strong>{inputValue}</strong>,{' '}
            <a
              href={`${whatsappMartin}?text=${encodeURIComponent(
                `Salut, c'est ${user.name} de Headlinker. Il manque le secteur ${inputValue}, tu peux l'ajouter s'il te plait ?`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="link-primary"
            >
              contacte Martin sur WhatsApp
            </a>{' '}
            pour l’ajouter
          </span>
        )
      }
      onChange={(selected: any) => {
        if (isMulti) {
          onChange(selected ? (selected || []).map((sel: Occupation) => sel._id) : []);
        } else {
          onChange(selected ? selected?._id : null);
        }
      }}
      {...props}
    />
  );
};

export default SelectOccupation;
